import React from "react"

const Logo3D = () => {
    return(
        <div>
            <canvas id="can" width="1024" height="512" >   
            </canvas>
        </div>

    )
}

export default Logo3D